var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.contest
    ? _c("aside", { staticClass: "contest-entry-form-aside" }, [
        _c("img", {
          staticClass: "contest-image",
          attrs: {
            src: _setup.contestImageUrl,
            alt: _vm.contest.contest,
            width: "236",
            height: "124",
            loading: "lazy",
          },
        }),
        _c("p", { staticClass: "contest-title" }, [
          _vm._v(_vm._s(_vm.contest.contest)),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }